module.exports = __webpack_public_path__ + "img/fois.b9eedf12.jpg";